<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-6">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/">Beranda</a></li>
            <li class="breadcrumb-item"><a href="/pages/user">User</a></li>
            <li class="breadcrumb-item active" aria-current="page">
              Tambah User Baru
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-6 text-end">
        <router-link to="/pages/user">
          <b-button variant="danger" class="btn btn-add btn-sm mb-2 px-4">
            <i class="fa fa-arrow-left mr-1"></i> &nbsp; Kembali</b-button
          >
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Data Users</h6>
          </div>
          <div class="card-body">
            <form class="row g-3 needs-validation" novalidate="">
              <div class="col-md-6 position-relative">
                <label class="form-label" for="validationTooltip01">Nama</label>
                <input
                  type="text"
                  class="form-control"
                  @change="validationForm"
                  v-bind:class="
                    formSubmitted ? (nameError ? 'is-invalid' : 'is-valid') : ''
                  "
                  id="name"
                  placeholder="Nama"
                  v-model="name"
                />
                <small
                  class="align-end text-danger"
                  v-if="errors[0] && formSubmitted"
                >
                  {{ errors[0].message }}
                </small>
              </div>
              <div class="col-md-6 position-relative">
                <label class="form-label" for="validationTooltip02"
                  >Email</label
                >
                <input
                  type="text"
                  class="form-control"
                  @change="validationForm"
                  v-bind:class="
                    formSubmitted
                      ? emailError
                        ? 'is-invalid'
                        : 'is-valid'
                      : ''
                  "
                  id="email"
                  placeholder="Email"
                  v-model="email"
                />
                <small class="text-danger" v-if="errors[1] && formSubmitted">
                  {{ errors[1].message }}
                </small>
              </div>
              <div class="col-md-6 position-relative">
                <label class="form-label" for="validationTooltip02"
                  >Nomer Hp</label
                >
                <input
                  type="text"
                  class="form-control"
                  @change="validationForm"
                  v-bind:class="
                    formSubmitted
                      ? no_hpError
                        ? 'is-invalid'
                        : 'is-valid'
                      : ''
                  "
                  id="no_hp"
                  placeholder="Nomer Hp"
                  v-model="no_hp"
                />
                <small class="text-danger" v-if="errors[3] && formSubmitted">
                  {{ errors[3].message }}
                </small>
              </div>
              <div class="col-md-6 position-relative">
                <label class="form-label" for="validationTooltip02"
                  >Role Akses</label
                >
                <select
                  type="text"
                  class="form-control"
                  id="jabatan_tim"
                  v-model="jabatan_tim"
                  @change="validationForm"
                  v-bind:class="
                    formSubmitted
                      ? jabatan_timError
                        ? 'is-invalid'
                        : 'is-valid'
                      : ''
                  "
                >
                  <option value="">Pilih Role</option>
                  <option value="superadmin">Superadmin</option>
                  <option value="admin">Admin</option>
                  <option value="reporter">Reporter</option>
                  <option value="viewer">Viewer</option>
                </select>
                <small class="text-danger" v-if="errors[2] && formSubmitted">
                  {{ errors[2].message }}
                </small>
              </div>
              <div class="col-md-6 position-relative">
                <label class="form-label" for="validationTooltip07"
                  >Password</label
                >
                <input
                  type="text"
                  class="form-control"
                  @change="validationForm"
                  v-bind:class="
                    formSubmitted
                      ? passwordError
                        ? 'is-invalid'
                        : 'is-valid'
                      : ''
                  "
                  id="password"
                  placeholder="Password"
                  v-model="password"
                />
                <small class="text-danger" v-if="errors[4] && formSubmitted">
                  {{ errors[4].message }}
                </small>
              </div>

              <div class="col-12 text-end">
                <button class="btn btn-light" @click="resetForm" type="button">
                  Reset
                </button>
                &nbsp;
                <button
                  class="btn btn-primary"
                  @click="simpanUsers"
                  type="button"
                >
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import UserAdminServiceService from "@/_services/user-admin.service.";
import Swal from "sweetalert2";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DropZone from "dropzone-vue";

export default {
  components: {
    ckeditor: CKEditor.component,
    DropZone,
  },
  data() {
    return {
      urlImage: process.env.VUE_APP_API_URL_IMAGE,
      loading: false,
      image_berita: "",
      previewUrl: null,
      image_beritaError: false,
      errors: [],
      formSubmitted: false,
      name: "",
      nameError: false,
      email: "",
      emailError: false,
      jabatan_tim: "",
      jabatan_timError: false,
      password: "",
      no_hp: "",
      no_hpError: false,
      validation: false,

      editor: ClassicEditor,
    };
  },

  methods: {
    imageberita(evt) {
      this.image_berita = evt.target.files[0];
      this.previewUrl = URL.createObjectURL(evt.target.files[0]);
    },

    validationForm() {
      this.errors = [];
      if (this.name.length < 1) {
        this.nameError = true;
        this.errors.push({
          message: "Nama harus di isi !",
        });
      } else {
        this.nameError = false;
        this.errors.push({
          message: "",
        });
      }
      if (this.email.length < 1) {
        this.emailError = true;
        this.errors.push({
          message: "Email harus di isi !",
        });
      } else {
        this.emailError = false;
        this.errors.push({
          message: "",
        });
      }
      if (this.jabatan_tim.length < 1) {
        this.jabatan_timError = true;
        this.errors.push({
          message: "Jabatan harus di isi !",
        });
      } else {
        this.jabatan_timError = false;
        this.errors.push({
          message: "",
        });
      }
      if (this.no_hp.length < 1) {
        this.no_hpError = true;
        this.errors.push({
          message: "Nomer Hp harus di isi !",
        });
      } else {
        this.no_hpError = false;
        this.errors.push({
          message: "",
        });
      }
      if (this.password.length < 6) {
        this.passwordError = true;
        this.errors.push({
          message: "Password harus di isi & Minimal 6 karakter !",
        });
      } else {
        this.passwordError = false;
        this.errors.push({
          message: "",
        });
      }
    },

    simpanUsers() {
      this.formSubmitted = true;
      this.validationForm();

      if (
        this.name &&
        this.email &&
        this.no_hp &&
        this.jabatan_tim &&
        this.password
      ) {
        this.validation = true;
        const formData = new FormData();
        formData.append("name", this.name);
        formData.append("email", this.email);
        formData.append("no_hp", this.no_hp);
        // formData.append("images", this.image_berita);
        formData.append("jabatan_tim", this.jabatan_tim);
        formData.append("password", this.password);
        UserAdminServiceService.add(formData)
          .then((response) => {
            console.log("berhasil", response.data);
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Data Berhasil Ditambah",
              showConfirmButton: false,
              timer: 1500,
            });
            this.loading = false;
            this.$router.push("/pages/user");
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Data Gagal Ditambah",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      }
    },

    resetForm() {
      console.log("rseset ");
      this.loading = false;
      this.image_berita = "";
      this.previewUrl = null;
      this.image_beritaError = false;
      this.errors = [];
      this.formSubmitted = false;
      this.name = "";
      this.nameError = false;
      this.email = "";
      this.emailError = false;
      this.jabatan_tim = "";
      this.jabatan_timError = false;
      this.password = "";
      this.no_hp = "";
      this.no_hpError = false;
      this.validation = false;
    },
  },
};
</script>

<style scoped>
@import "dropzone-vue/dist/dropzone-vue.common.css";
.customize-table {
  --easy-table-header-font-size: 14px;
  --easy-table-header-height: 40px;
  --easy-table-body-row-height: 40px;
  --easy-table-body-row-font-size: 14px;
}

.searchBar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

#searchQueryInput {
  width: 100%;
  height: 2.4rem;
  background: #f5f5f5;
  outline: none;
  border: none;
  border-radius: 1.625rem;
  padding: 0 3.5rem 0 1.5rem;
  font-size: 1rem;
}

#searchQuerySubmit {
  width: 3.5rem;
  height: 2.8rem;
  margin-left: -3.5rem;
  background: none;
  border: none;
  outline: none;
}

#searchQuerySubmit:hover {
  cursor: pointer;
}

.font-large-2 {
  font-size: 3rem !important;
}

.form-control {
  border: #a8a7a7 1.4px solid;
}

.form-control:focus {
  border: #a8a7a7 1.7px solid;
}

.count {
  background: rgb(149, 2, 13);
  background: radial-gradient(
    circle,
    rgba(149, 2, 13, 1) 0%,
    rgba(216, 49, 61, 1) 100%
  );
}
</style>
